import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { runtimeConfig } from './config/runtime';
import './index.css';
import reportWebVitals from './reportWebVitals';
import oauthService from './services/oauth';

// Initialize runtime configuration before starting the app
async function initializeApp() {
  try {
    await runtimeConfig.initialize();

    // Reinitialize OAuth service after runtime config is loaded
    oauthService.reinitialize();
  } catch (error) {
    // Failed to initialize runtime configuration
  }

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Start the app
initializeApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
